import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtohavericab() {



    const cardData = {




keyword: "Belgaum to Haveri Cab",

headingDescription: "Belgaum Taxi Service offers comfortable and reliable Belgaum to Haveri cab services for business travel, family trips, educational visits, medical journeys, and outstation transportation. Whether you need a one-way taxi or a round-trip cab from Belgaum to Haveri, we provide safe and convenient travel with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel requirements. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth journey. Belgaum Taxi Service provides hassle-free cab connectivity between Belgaum and Haveri for families, professionals, students, and travelers exploring Karnataka.",

topPlaces: [
  {
    title: "Haveri",
    description: "Haveri is an important city in Karnataka known for agriculture, temples, historical attractions, and commercial activities. It is a frequently traveled destination from Belgaum."
  },
  {
    title: "Ranebennur",
    description: "Ranebennur is a major town near Haveri known for business activities, wildlife sanctuary, and local markets, making it a popular travel destination."
  },
  {
    title: "Siddeshwara Temple",
    description: "Siddeshwara Temple in Haveri is a famous historical temple known for beautiful architecture and cultural importance, attracting visitors throughout the year."
  },
  {
    title: "Bankapura",
    description: "Bankapura is a historic town near Haveri known for Bankapura Fort and cultural heritage sites, making it a preferred destination for history lovers."
  },
  {
    title: "Shiggaon",
    description: "Shiggaon is a growing town near Haveri with religious attractions and business activities, offering easy connectivity from nearby cities."
  },
  {
    title: "Hubballi",
    description: "Hubballi is a major commercial city near Haveri known for business, education, healthcare, and transportation facilities."
  },
  {
    title: "Dharwad",
    description: "Dharwad is an educational and cultural city in Karnataka known for universities, institutions, and heritage attractions, making it a common travel destination."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's leading IT and business hub with corporate offices, technology parks, and commercial centers. Long-distance cabs provide comfortable connectivity."
  },
  {
    title: "Goa",
    description: "Goa is a popular tourist destination famous for beaches, resorts, churches, and sightseeing attractions. Private cabs provide convenient travel for holiday trips."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site known for ancient ruins, temples, and historical monuments, making it a popular heritage destination in Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Haveri Taxi",
    "description": "Book Belgaum to Haveri Taxi for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Enjoy convenient transportation for personal trips, family visits, business travel, and regular journeys with flexible booking options."
  },
  {
    "name": "Belgaum to Haveri Cab Service",
    "description": "Choose Belgaum to Haveri Cab Service for dependable intercity travel with experienced drivers, clean vehicles, and affordable pricing. Get comfortable Sedan, Ertiga, Innova Crysta, and SUV cab options for a smooth journey."
  },
  {
    "name": "Belgaum to Haveri Taxi Service",
    "description": "Hire Belgaum to Haveri Taxi Service for hassle-free transportation with doorstep pickup, professional chauffeurs, and flexible travel packages. Suitable for family travel, corporate trips, and outstation requirements."
  },
  {
    "name": "Belgaum to Haveri One Way Cab",
    "description": "Book Belgaum to Haveri One Way Cab for economical point-to-point travel without return charges. Enjoy transparent fares, comfortable AC vehicles, and reliable drivers for a convenient journey."
  },
  {
    "name": "Belgaum to Haveri One Way Taxi",
    "description": "Choose Belgaum to Haveri One Way Taxi for affordable single-trip transportation. Get quick booking, clean vehicles, and experienced chauffeurs for safe and comfortable travel."
  },
  {
    "name": "Belgaum to Haveri Cab Booking",
    "description": "Complete Belgaum to Haveri Cab Booking with easy reservations and instant confirmation. Select from multiple vehicle categories based on passenger requirements and travel comfort."
  },
  {
    "name": "Belgaum to Haveri Taxi Booking",
    "description": "Book Belgaum to Haveri Taxi Booking services for reliable and convenient transportation. Enjoy professional drivers, affordable rates, and flexible one way or round trip options."
  },
  {
    "name": "Belgaum to Haveri Car Rental",
    "description": "Choose Belgaum to Haveri Car Rental with driver for comfortable and flexible travel solutions. Hire well-maintained cars for family trips, business travel, sightseeing, and personal journeys."
  },
  {
    "name": "Belgaum to Haveri Outstation Cab",
    "description": "Travel with Belgaum to Haveri Outstation Cab services offering safe and comfortable long-distance transportation. Get reliable vehicles, professional chauffeurs, and convenient travel packages."
  },
  {
    "name": "Belgaum to Haveri Innova Crysta Cab",
    "description": "Book Belgaum to Haveri Innova Crysta Cab for premium and spacious travel. Enjoy luxury seating, large luggage space, and comfortable journeys for families, groups, and corporate passengers."
  },
  {
    "name": "Belgaum to Haveri Ertiga Cab",
    "description": "Hire Belgaum to Haveri Ertiga Cab for comfortable 6 to 7 seater travel. Ideal for family trips, group transportation, airport transfers, and outstation journeys."
  },
  {
    "name": "Belgaum to Haveri Sedan Cab",
    "description": "Choose Belgaum to Haveri Sedan Cab for economical and comfortable transportation. Travel with clean AC sedans and professional drivers for business and personal requirements."
  },
  {
    "name": "Belgaum to Haveri Round Trip Cab",
    "description": "Book Belgaum to Haveri Round Trip Cab for flexible return travel with affordable packages. Perfect for family visits, business meetings, sightseeing, and planned journeys."
  },
  {
    "name": "Belgaum to Haveri Private Taxi",
    "description": "Hire Belgaum to Haveri Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and flexible schedules throughout your trip."
  },
  {
    "name": "Cheap Belgaum to Haveri Cab",
    "description": "Find Cheap Belgaum to Haveri Cab services with affordable fares, quality vehicles, and reliable drivers. Travel comfortably with budget-friendly taxi solutions without compromising safety."
  },
  {
    "name": "Best Belgaum to Haveri Cab Service",
    "description": "Choose the Best Belgaum to Haveri Cab Service with premium vehicles, experienced chauffeurs, and competitive pricing. Get dependable travel solutions for families, individuals, and corporate customers."
  },
  {
    "name": "Online Belgaum to Haveri Cab Booking",
    "description": "Book Online Belgaum to Haveri Cab Booking services with easy online reservations and quick confirmation. Select your preferred cab for comfortable and convenient travel."
  },
  {
    "name": "Belgaum to Haveri Taxi Fare",
    "description": "Get affordable Belgaum to Haveri Taxi Fare with transparent pricing and flexible packages. Choose Sedan, Ertiga, Innova Crysta, or SUV vehicles according to your travel needs."
  },
  {
    "name": "Belgaum to Haveri Car Hire",
    "description": "Hire Belgaum to Haveri Car Hire services with reliable vehicles and professional drivers. Suitable for family travel, corporate visits, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Haveri Cab Price",
    "description": "Check Belgaum to Haveri Cab Price and select affordable travel options. Enjoy comfortable AC cabs with flexible booking facilities for one way and round trip journeys."
  },
  {
    "name": "Belgaum to Haveri Family Cab",
    "description": "Book Belgaum to Haveri Family Cab for safe and spacious travel. Get comfortable seating, experienced drivers, and reliable transportation for family trips and personal visits."
  },
  {
    "name": "Belgaum to Haveri Corporate Taxi",
    "description": "Choose Belgaum to Haveri Corporate Taxi services for professional business transportation. Get punctual service, reliable vehicles, and trained chauffeurs for corporate travel needs."
  },
  {
    "name": "Belgaum to Haveri Airport Transfer",
    "description": "Book Belgaum to Haveri Airport Transfer service for timely pickup and drop facilities. Travel comfortably with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Haveri Cab Fare",
    "description": "Get details about Belgaum to Haveri Cab Fare with affordable rates and multiple vehicle options. Choose the right cab according to your journey requirements."
  },
  {
    "name": "Belgaum to Haveri Taxi Near Me",
    "description": "Find Belgaum to Haveri Taxi Near Me for quick and reliable taxi availability. Book comfortable cabs with experienced drivers for safe and convenient travel."
  },
  {
    "name": "Belgaum to Haveri Outstation Taxi",
    "description": "Hire Belgaum to Haveri Outstation Taxi for comfortable long-distance travel with clean vehicles and professional chauffeurs. Enjoy reliable transportation for personal, family, and business journeys."
  },
  {
    "name": "Belgaum to Haveri Travel by Cab",
    "description": "Travel from Belgaum to Haveri by Cab with convenient booking options, comfortable vehicles, and experienced drivers. Enjoy smooth and stress-free transportation throughout your journey."
  }
],
"tableData": [
  ["Belgaum to Haveri Taxi", "Belgaum to Haveri Cab Service"],
  ["Belgaum to Haveri Taxi Service", "Belgaum to Haveri One Way Cab"],
  ["Belgaum to Haveri One Way Taxi", "Belgaum to Haveri Cab Booking"],
  ["Belgaum to Haveri Taxi Booking", "Belgaum to Haveri Car Rental"],
  ["Belgaum to Haveri Outstation Cab", "Belgaum to Haveri Innova Crysta Cab"],
  ["Belgaum to Haveri Ertiga Cab", "Belgaum to Haveri Sedan Cab"],
  ["Belgaum to Haveri Round Trip Cab", "Belgaum to Haveri Private Taxi"],
  ["Cheap Belgaum to Haveri Cab", "Best Belgaum to Haveri Cab Service"],
  ["Online Belgaum to Haveri Cab Booking", "Belgaum to Haveri Taxi Fare"],
  ["Belgaum to Haveri Car Hire", "Belgaum to Haveri Cab Price"],
  ["Belgaum to Haveri Family Cab", "Belgaum to Haveri Corporate Taxi"],
  ["Belgaum to Haveri Airport Transfer", "Belgaum to Haveri Cab Fare"],
  ["Belgaum to Haveri Taxi Near Me", "Belgaum to Haveri Outstation Taxi"],
  ["Belgaum to Haveri Travel by Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Haveri Cab Service",
    WhyChoosedescription: "Travel from Belgaum to Haveri with a convenient taxi solution offering comfortable vehicles, experienced chauffeurs, and flexible travel options for a smooth journey."
  },
  {
    WhyChooseheading: "Easy Intercity Travel Experience",
    WhyChoosedescription: "Enjoy direct transportation between Belgaum and Haveri with convenient pickup and drop facilities designed to make your travel simple and comfortable."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Select from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs according to your group size, luggage, and comfort requirements."
  },
  {
    WhyChooseheading: "Perfect for Family & Professional Trips",
    WhyChoosedescription: "Our Belgaum to Haveri taxis are suitable for family visits, business travel, personal work, medical trips, and outstation transportation."
  },
  {
    WhyChooseheading: "Experienced Drivers for Better Travel",
    WhyChoosedescription: "Professional chauffeurs ensure smooth driving, timely service, and a comfortable ride with good knowledge of the Belgaum to Haveri route."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Cabs",
    WhyChoosedescription: "Choose a one-way taxi for direct travel or select a round-trip package based on your schedule and travel requirements."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Long Routes",
    WhyChoosedescription: "Well-maintained cars with clean interiors and spacious seating provide a relaxed travel experience throughout your journey."
  },
  {
    WhyChooseheading: "Quick Booking & Travel Support",
    WhyChoosedescription: "Get assistance for vehicle selection, fare details, and cab availability to plan your Belgaum to Haveri trip easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Haveri Cab Service?",
    answer: "Yes, we provide Belgaum to Haveri cab services with comfortable vehicles and professional drivers for convenient travel."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Haveri?",
    answer: "Yes, one-way taxi service is available for passengers who require direct transportation between Belgaum and Haveri."
  },
  {
    question: "Which vehicles are available for Belgaum to Haveri travel?",
    answer: "You can choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs based on your requirements."
  },
  {
    question: "Is Belgaum to Haveri taxi suitable for family trips?",
    answer: "Yes, spacious and comfortable vehicles are available for families and groups travelling from Belgaum to Haveri."
  },
  {
    question: "Can I book a return taxi from Haveri to Belgaum?",
    answer: "Yes, return journey cabs are available with flexible travel timings according to your convenience."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Haveri?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Additional charges such as toll, parking, and other applicable fees depend on the selected package and are informed during booking."
  },
  {
    question: "Is Belgaum to Haveri cab service available 24/7?",
    answer: "Yes, taxi booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Haveri Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Deshmukh",
    feedback: "The Belgaum to Haveri cab service was comfortable and well managed. The driver was professional, and the vehicle was in excellent condition.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Poonam Patil",
    feedback: "We had a smooth journey with timely pickup and a comfortable car. The overall taxi experience was convenient and reliable.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Haveri Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-haveri-cab.webp",
  "description":
    "Book Belgaum to Haveri Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Haveri with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, business trips, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-haveri-cab"
  }
};





    return (
        <div>



<Helmet>
  <title>Belgaum to Haveri Cab | Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Haveri Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Haveri with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable local and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Haveri Taxi, Belgaum to Haveri Cab Service, Belgaum to Haveri Taxi Service, Belgaum to Haveri Cab, Belgaum to Haveri One Way Cab, Belgaum to Haveri Cab Booking, Belgaum to Haveri Car Rental, Belgaum to Haveri Outstation Cab, Belgaum to Haveri Taxi Fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtohavericab;